import {COLORS} from '../../helpers'

export default {
  icon: {
    fill: COLORS.text
  },
};